export { useLinkContext, LinkContextProvider, linkContextDefaultValue } from '@fluentui/react-link';
export type { LinkContextValue } from '@fluentui/react-link';
